<script lang="ts">
import { type Snippet } from 'svelte'
import { fly } from 'svelte/transition'

type Props = {
	animationDelay?: number
	testId?: string
	isContact?: boolean
	children?: Snippet
}

let { animationDelay = 0, testId, isContact = false, children }: Props = $props()
</script>

<div
	class={['flex relative', isContact && 'justify-end']}
	in:fly|global={{ duration: 350, x: -20, delay: animationDelay }}
	data-testid={testId}
>
	{@render children?.()}
</div>
